import { FileHelpers } from "../../../utils/helpers/File.helpers";
import API from "../../../utils/helpers/API.helpers";
import MKSpesialHelper from "../../../utils/helpers/MKSpesial.helpers";

const checkSaranPenguji = (MKSpesialDetails) => {
  if (MKSpesialDetails.saran_penguji.length !== 0) return MKSpesialDetails;
  delete MKSpesialDetails.saran_penguji;
  return MKSpesialDetails;
};

const MKSpesialService = {
  async getMKSpesialList(term = null) {
    if (term) {
      return await API.get({ endpoint: `/mk-spesial/?term=${term}` });
    }
    return await API.get({ endpoint: "/mk-spesial/" });
  },
  async getMKSpesialByID(mKSpesialID) {
    return await API.get({ endpoint: `/mk-spesial/${mKSpesialID}/` });
  },
  async createMKSpesial(MKSpesialDetails) {
    let data = MKSpesialHelper.parseDetailsForCreateUpdate(MKSpesialDetails);
    return await API.post({
      endpoint: "/mk-spesial/",
      data: checkSaranPenguji(data),
    });
  },
  async updateMKSpesial(MKSpesialDetails) {
    let data = MKSpesialHelper.parseDetailsForCreateUpdate(MKSpesialDetails);
    return await API.put({
      endpoint: `/mk-spesial/${data.id}/`,
      data: checkSaranPenguji(data),
    });
  },
  async deleteMKSpesial(MKSpesialID) {
    return await API.delete({ endpoint: `/mk-spesial/${MKSpesialID}/` });
  },
  async getApprovedMKSpesial(termId = null) {
    let endpoint = "/mk-spesial/get-approved-sidang";
    if (termId != null) endpoint = endpoint + `?term${termId}`;
    return await API.get({ endpoint: endpoint });
  },
  async bulkCreateMKSpesial(excelFile) {
    if (!excelFile) return;
    let excelAsBase64 = null;
    await FileHelpers.fileToBase64(excelFile)
      .then((result) => (excelAsBase64 = result))
      .catch((error) => console.log(error));
    return await API.post({
      endpoint: "/file/bulk-create-mkspesial/",
      data: { file: excelAsBase64 },
    });
  },
  async bulkCreateMKSpesialAndMahasiswa(excelFile) {
    if (!excelFile) return;
    let excelAsBase64 = null;
    await FileHelpers.fileToBase64(excelFile)
      .then((result) => (excelAsBase64 = result))
      .catch((error) => console.log(error));
    return await API.post({
      endpoint: "/file/bulk-create-mkspesial-mahasiswa/",
      data: { file: excelAsBase64 },
    });
  },
  async getDetailMKSpesial(MKSpesialID) {
    return await API.get({ endpoint: `/mk-spesial/dashboard/${MKSpesialID}/` });
  },
  async getStatusMKSpesial(MKSpesialID) {
    return await API.get({ endpoint: `/mk-spesial/${MKSpesialID}/status/` });
  },
};

export default MKSpesialService;
